import React, { useState } from "react"

import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { StyledLink, WithLoadingIndicator } from "~tailwindui/Basics"
import Table from "~tailwindui/Table/Table"

const ChangesRequestedExpenses = () => {
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: expensesQuery,
    variables: { page },
  })

  if (result.data && result.data.expenses.data.length === 0) return null

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { expenses } }) => (
        <Table
          title="Changes Requested Expenses"
          data={expenses}
          changePage={setPage}
          cols={[
            { header: "Description", value: expense => expense.description },
            { header: "Type", value: expense => expense.expenseType },
            { header: "Amount", value: expense => expense.formattedAmount },
            { header: "Your Comments", value: expense => expense.comments },
            { header: "Admin Feedback", value: expense => expense.feedback },
            {
              header: "Actions",
              value: expense => (
                <StyledLink
                  key={expense.id}
                  to={path("expenseEdit", { id: expense.id })}
                  button
                >
                  Edit
                </StyledLink>
              ),
            },
          ]}
        />
      )}
    </WithLoadingIndicator>
  )
}

const expensesQuery = gql`
  query ChangesRequestedExpenses($page: Int!) {
    expenses(page: $page, state: changes_requested) {
      currentPage
      totalPages
      data {
        id
        expenseType
        description
        comments
        feedback
        formattedAmount
      }
    }
  }
`

export default ChangesRequestedExpenses
